'use client';

import { SubscriptionTitle } from '@/types/Subscription';
import PlanFlowerPink from 'public/img/icon/plan-icon-flower-pink.svg';
import PlanFlowerRose from 'public/img/icon/plan-icon-flower-rose.svg';
import PlanFlowerMaroon from 'public/img/icon/plan-icon-flower-maroon.svg';
import PlanDoubleFlower from 'public/img/icon/plan-icon-2flower.svg';
import PlanDoubleFlowerPink from 'public/img/icon/plan-icon-2flower-pink.svg';

export function getTierIconByName(tier: Omit<SubscriptionTitle, 'Privee'>) {
  switch (tier) {
    case 'Premier': {
      return PlanFlowerPink;
    }

    case 'Classique': {
      return PlanFlowerRose;
    }

    case 'Couture': {
      return PlanFlowerMaroon;
    }

    case 'Classique+': {
      return PlanDoubleFlowerPink;
    }

    case 'Couture+': {
      return PlanDoubleFlower;
    }
  }
}
